import styled from 'styled-components';

export const UploadCSVContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  padding-top: 20px;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  flex: 1;
`;

export const ContentContainer = styled.main`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StepperContainer = styled.div`
  flex-direction: column;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 20px;
`;
